var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "box_nav_sign"
  }, [_c("div", {
    staticClass: "Qm_box_sing"
  }, [_c("div", {
    staticClass: "singn_tit"
  }, [_vm._v("请在下方空白区域进行签名动作，完成签名后点击[上传]按钮")]), _vm.isEdit ? _c("div", [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSignature,
      expression: "showSignature"
    }],
    staticClass: "QM_tit"
  }, [_c("canvas", {
    ref: "canvas",
    style: {
      width: _vm.canvasWidth + "px",
      height: _vm.canvasHeight + "px"
    },
    on: {
      mousedown: _vm.startDrawing,
      mousemove: _vm.draw,
      mouseup: _vm.stopDrawing
    }
  })]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showSignature,
      expression: "!showSignature"
    }],
    staticClass: "QM_tit"
  }, [_c("img", {
    staticStyle: {
      width: "870px",
      height: "200px"
    },
    attrs: {
      src: _vm.itemData.value
    }
  })])]) : _c("div", [_c("div", {
    staticClass: "QM_tit"
  }, [_c("img", {
    staticStyle: {
      width: "870px",
      height: "200px"
    },
    attrs: {
      src: _vm.itemData.value
    }
  })])]), _c("div", {
    staticClass: "but_box"
  }, [_c("a-button", {
    attrs: {
      type: "danger",
      disabled: !_vm.isEdit
    },
    on: {
      click: _vm.clearCanvas
    }
  }, [_vm._v(" 清除 ")]), _vm.isEdit == false ? [_c("a-button", {
    attrs: {
      type: "primary",
      disabled: true
    },
    on: {
      click: _vm.saveSignature
    }
  }, [_vm._v("上传 ")])] : [_c("a-button", {
    attrs: {
      type: "primary",
      disabled: _vm.isUploading
    },
    on: {
      click: _vm.saveSignature
    }
  }, [_vm._v("上传 ")])]], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };